import { IShellEvent } from './IShellEvent';
import { Subject } from 'rxjs';
import { EventHeaderBase, SystemHeader } from '@itero/itero-client-communication';

export type PublishEventFn = (eventName: string, targetApplications: Array<string>, eventPayload?: any) => Promise<void>;

export abstract class BaseShellEvent<
	T extends {
		systemHeader: SystemHeader;
		eventHeader: EventHeaderBase;
	},
> implements IShellEvent
{
	protected subject = new Subject<T>();
	public readonly event$ = this.subject.pipe();

	abstract get eventName();

	handleCustomEvent(event: T, publishEventFunc?: PublishEventFn): void {
		this.subject.next(event);
	}
	handlePostMessage(event: T, callback?: PublishEventFn): void {}
}
